var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69565 9.16644C7.53855 9.16644 7.38145 9.10753 7.2538 8.9897C7.00834 8.74423 7.00834 8.35149 7.2538 8.11584L13.1843 2.18532C13.4298 1.93985 13.8225 1.93985 14.0582 2.18532C14.3037 2.43079 14.3037 2.82354 14.0582 3.05919L8.12767 8.9897C8.00985 9.10753 7.85275 9.16644 7.69565 9.16644Z",
    fill: "#2469EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.497 14.9987H3.50302C2.3935 14.9987 1.5 14.1052 1.5 12.9957V4.01157C1.5 2.90205 2.3935 2.00854 3.50302 2.00854H7.54834C7.89199 2.00854 8.16692 2.28347 8.16692 2.62713C8.16692 2.97078 7.89199 3.24571 7.54834 3.24571H3.50302C3.08082 3.24571 2.73716 3.58936 2.73716 4.01157V13.0055C2.73716 13.4277 3.08082 13.7714 3.50302 13.7714H12.497C12.9192 13.7714 13.2628 13.4277 13.2628 13.0055V7.73287C13.2628 7.38921 13.5378 7.11429 13.8814 7.11429C14.2251 7.11429 14.5 7.38921 14.5 7.73287V12.9957C14.5 14.1052 13.5967 14.9987 12.497 14.9987Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bb3632e549743558755efd5eec967aa6.svg";
export { ForwardRef as ReactComponent };